exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1ozu8nWumEdfSO{align-items:center;background-color:rgba(9,45,66,.13);border-radius:18px;color:rgba(9,45,66,.54);display:flex;font-size:10px;height:16px;justify-content:center;min-width:24px}._30LjLtyl_xC8Nk._1ozu8nWumEdfSO,button:active ._1ozu8nWumEdfSO,button:hover ._1ozu8nWumEdfSO{color:rgba(9,45,66,.71)}.jVUSRinC9UMLtG{margin-top:4px}.KgetaQ0wnnmuZ8:first-of-type .jVUSRinC9UMLtG{margin-top:0}", ""]);

// exports
exports.locals = {
	"countContainer": "_1ozu8nWumEdfSO",
	"selected": "_30LjLtyl_xC8Nk",
	"cardDueTabButton": "jVUSRinC9UMLtG",
	"cardDueContainer": "KgetaQ0wnnmuZ8"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"modules":true,"importLoaders":2,"localIdentName":"[hash:base64:14]","sourceMap":false}!./node_modules/postcss-loader/lib?{"config":{"path":"/buildeng/bamboo-agent-home/xml-data/build-dir/TRE-WEB-BWP/.build/prod/build-2936/tools/webpack/postcss.config.js"},"sourceMap":true}!./node_modules/less-loader/dist/cjs.js?{"outputStyle":"expanded","sourceMap":false}!./app/scripts/views/home/presentational/team-card-due-scroll-navigation.less
// module id = UBck
// module chunks = 13